/* Page to fetch the Shooting Schedule Days data and all 
   Schedule Scenes
 * Contains DayTop component to which it passes the
   Day's cover info and the Schedule Scenes
 * Contains the link to the DayCreateForm component
 * Contains the Calendar component */
import React, { useEffect, useState } from "react";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar";
import { useHistory } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import NoResults from "../../assets/no-results.png";
import Asset from "../../components/Asset";
import TopBox from "../../components/TopBox";
import DayTop from "./day/DayTop";
import Info from "./Info";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import { formatScheduleDate } from "../../utils/date";

import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";
import appStyles from "../../App.module.css";
import "react-calendar/dist/Calendar.css";

const SchedulePages = () => {
  const host = useHostName();
  // eslint-disable-next-line
  const currentUser = useCurrentUser();
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const [today] = useState(new Date());
  const [newdate, setNewdate] = useState("");
  const [days, setDays] = useState({ results: [] });
  const [daysScenes, setDaysScenes] = useState({ results: [] });
  // eslint-disable-next-line
  const [error, setError] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);
  const [query, setQuery] = useState("");
  const filter = "";
  const message = "No Days Added";
  const history = useHistory();
  const [showInfo, setShowInfo] = useState(false);

  const fetchDays = async () => {
      /* Fetch all Days and all schedule scenes */
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [{ data: daysData }, { data: scenesData }] = await Promise.all([
            axiosReq.get(`days/?${filter}&search=${query}`),
            axiosReq.get(`schedule/scenes`),
          ]);
          setDays(daysData);
          setDaysScenes(scenesData);
          setHasLoaded(true);
        } else {
          const [{ data: daysData }, { data: scenesData }] = await Promise.all([
            axiosInstance.get(
              // if epi is present, add it to the query string
              `${localStorage.getItem(
                "projectSlug"
              )}/days/?${filter}&search=${query}${
                epi ? `&episode_ids=${epi}` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/schedule/scenes`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
          ]);
          setDays(daysData);
          setDaysScenes(scenesData);
          setHasLoaded(true);
        }
      } catch (err) {
        setError(err);
        console.log(err);
      }
    };

  useEffect(() => {
    setHasLoaded(false);

    const timer = setTimeout(() => {
      fetchDays();
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [query, filter]);

  const handleDate = (date) => {
    /* Change the Calander date format to the DRF model's format */
    const formatdate = formatScheduleDate(date);
    setNewdate(formatdate);
  };

  return (
    <div>
      <TopBox title="Schedule" episodeTitle={`Episode ${episodeTitle}`} />
      {/* back info */}
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      <Row>
          <Col>
            <h3 className="text-center">SHOOT DAYS</h3>
            <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
          </Col>
        </Row>  
      {!showInfo ? "" : <Info />}
      {/* add day */}
      <Row className="mt-3 mb-2">
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/days/create${
                      epi && project && episodeTitle
                        ? `?episodeid=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                        : ""
                    }`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Create Day
              </Button>
            )}
        </Col>
      </Row>
      <div>
        {/* search */}
        <Row>
          <Col
            className="mt-3"
            xs={{ span: 10, offset: 1 }}
            md={{ span: 6, offset: 3 }}
          >
            <Form
              onSubmit={(event) => event.preventDefault()}
            >
              <Form.Control
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                type="text"
                className={`${styles.InputBar}`}
                placeholder="Search by Day Number"
              />
            </Form>
          </Col>
        </Row>
        {/* days */}
        <Row className="mt-2 mb-5">
          {hasLoaded ? (
            <>
              {days?.results?.length ? (
                days?.results?.map((day) => (
                  <Col
                    key={day.id}
                    xs={{ span: 10, offset: 1 }}
                    sm={{ span: 6, offset: 0 }}
                    lg={4}
                    className="py-2"
                  >
                    <DayTop
                      daysScenes={daysScenes}
                      {...day}
                      setDays={setDays}
                      epi={epi}
                      project={project}
                      episodeTitle={episodeTitle}
                      fetchDays={fetchDays}
                    />
                  </Col>
                ))
              ) : (
                <Container className={appStyles.Content}>
                  {query ? (
                    <Asset src={NoResults}
                    message="No Results"
                  />) : (
                  <Asset src={NoResults}
                  message={message}
                  />) } 
                </Container>
              )}
            </>
          ) : (
            <Container className={appStyles.Content}>
              <Asset spinner />
            </Container>
          )}
        </Row>
      </div>
      {/* calender */}
      <div className="mx-3 mx-md-5 px-md-5">
      <h5 className={`mt-3 text-center py-1 ${styles.SubTitle}`}>
        Shoot Days Calendar
      </h5>
      <div>
      <Row className='text-center'>
      <Col>
      <p className={`text-center py-1 ${styles.SmallDepts}`}>
        FIND SHOOT DAYS BY DATE
      </p>
      </Col>
    </Row>
        <Row className={`mx-1 py-3`}>
          <Col>
            <div>
              <Row>
                <Col className="d-flex justify-content-center " xs={12} md={6}>
                  <Calendar
                    onChange={(date) => handleDate(date)}
                    value={today}
                  />
                </Col>
                <Col className="p-1" xs={12} md={6}>
                <Row className='text-center'>
                  <Col>
                  <p>Click on a date to find its Shoot Day if one has been
                    created.
                  </p>
                  <p>
                  If one has not been created for that date nothing will show.
                  </p>
                  </Col>
                </Row>
                  <Row className="mt-3">
                    <Col
                      xs={{ span: 10, offset: 1 }}
                      md={{ span: 8, offset: 2 }}
                      className="mt-3 text-center"
                    >
                      {days?.results?.map((day) =>
                        day.date === newdate ? (
                          <DayTop daysScenes={daysScenes} {...day}
                          fetchDays={fetchDays} />
                        ) : (
                          ""
                        )
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        </div>
      </div>
    </div>
  );
};

export default SchedulePages;
